package com.patronat.top.features.venues.presentation

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

data class MapLibreConfig(
    val apiKey: String,
    val style: String
)

data class VenueMapMarker(
    val id: String,
    val latitude: Double,
    val longitude: Double,
    val title: String,
    val description: String? = null
)

data class MapTilerAddressResult(
    val id: String,
    val placeName: String,
    val latitude: Double,
    val longitude: Double,
    val relevance: Double,
    val placeType: List<String>
)

@Composable
internal expect fun MapLibreVenueMap(
    selectedLatitude: Double?,
    selectedLongitude: Double?,
    mapLibreConfig: MapLibreConfig,
    venueMarkers: List<VenueMapMarker> = emptyList(),
    onPointSelected: (latitude: Double, longitude: Double) -> Unit,
    onMarkerClicked: (VenueMapMarker) -> Unit = {},
    modifier: Modifier = Modifier,
    zoom: Double = 15.0,
    interactive: Boolean = true
)

internal expect fun isMapLibreSupported(): Boolean

internal expect suspend fun searchMapTilerAddresses(
    query: String,
    apiKey: String,
    proximity: Pair<Double, Double>? = null,
    countryCode: String = "UA",
    limit: Int = 5
): List<MapTilerAddressResult>

internal expect suspend fun reverseMapTilerGeocode(
    latitude: Double,
    longitude: Double,
    apiKey: String
): MapTilerAddressResult?